export class BookingPartialPaymentModel {
  public amount: number; // amount in forign or eur currency
  public eurAmount: number;
  public editorCurrency: string; // currency selected from UI for the last time
  public dueDate: Date;

  public constructor(amount?: number, eurAmount?: number, editorCurrency?: string, dueDate?: Date) {
    this.amount = amount;
    this.eurAmount = eurAmount;
    this.editorCurrency = editorCurrency;
    this.dueDate = dueDate;
  }
}
